import { render } from "./aio-login-recent-activity.vue?vue&type=template&id=e2315398&scoped=true"
import script from "./aio-login-recent-activity.vue?vue&type=script&lang=js"
export * from "./aio-login-recent-activity.vue?vue&type=script&lang=js"

import "./aio-login-recent-activity.vue?vue&type=style&index=0&id=e2315398&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2315398"]])

export default __exports__